import type { ComponentType } from 'react';
import React from 'react';
import type {
  Location,
  NavigateFunction,
  Params,
} from 'react-router-dom';
import {
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

export interface RouterProps {
  navigate: NavigateFunction;
  readonly params: Params<string>;
  location: Location;
}

type OmitRouter<T> = Omit<T, keyof RouterProps>;

/**
 * withRouter HOC disappeared when upgrading react-router-dom from v5 to v6
 *
 * https://reactrouter.com/docs/en/v6/getting-started/faq#what-happened-to-withrouter-i-need-it
 * https://github.com/remix-run/react-router/issues/8146#issuecomment-1109534957
 */
export function withRouter<T>(
  Component: ComponentType<OmitRouter<T> & RouterProps>,
) {
  // eslint-disable-next-line react/display-name
  return (props: OmitRouter<T>) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
      <Component
        location={location}
        navigate={navigate}
        params={params}
         
        {...props}
      />
    );
  };
}
